export default __webpack_public_path__ + "static/media/sd-sakshi-ganapati-abhisekam.f81e6e3d.jpg";